import { render, staticRenderFns } from "./info.vue?vue&type=template&id=43236a40&scoped=true&lang=html&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&id=43236a40&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43236a40",
  null
  
)

component.options.__file = "info.vue"
export default component.exports